import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { currentUser, isLoading } = useAuth();
  const location = useLocation();
  
  // If still loading auth state, show nothing (or could add a loading spinner)
  if (isLoading) {
    return null;
  }

  // Check if this is a dashboard route
  const isDashboardRoute = location.pathname.startsWith('/dashboard');
  
  // For dashboard routes, we need to check if the user is TBAdmin
  // For regular routes, we just need to check if the user is logged in
  if (isDashboardRoute) {
    // For dashboard routes, check if user is TBAdmin
    // This is a simplified check - in a real app, you would check the user's role
    const isAdmin = currentUser && currentUser.username === 'TBAdmin';
    
    if (!isAdmin) {
      // If not admin, redirect to dashboard login
      return <Navigate to="/dashboard/login" />;
    }
  } else {
    // For regular routes, check if user is logged in
    if (!currentUser) {
      // If not logged in, redirect to login page
      return <Navigate to="/login" />;
    }
  }

  // If logged in with appropriate permissions, show the protected content
  return <>{children}</>;
};

export default PrivateRoute; 